// Shared Ant Design theme tokens for the app - warm, food-friendly palette
// instead of antd's default blue.
export const theme = {
  token: {
    colorPrimary: '#d4622a',
    colorLink: '#d4622a',
    colorLinkHover: '#e07a44',
    borderRadius: 8,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  components: {
    Layout: {
      headerBg: '#20140f',
      bodyBg: '#faf6f2',
    },
    Menu: {
      darkItemBg: '#20140f',
      darkItemSelectedBg: '#d4622a',
      darkItemHoverBg: 'rgba(255,255,255,0.08)',
    },
    Card: {
      borderRadiusLG: 12,
    },
  },
};
